import React from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'

const buttonClasses = function (active) {
  return [
    "fdn-search-control uk-button uk-button-default",
    active ? "uk-active" : "",
  ].join(" ")
}

export class ControlBar extends React.Component {
  static get propTypes () {
    return {
      children: PropTypes.node
    }
  }

  render () {
    return (
      <div className="fdn-search-control-row">
        { this.props.children }
      </div>
    )
  }
}


export class ControlGroup extends React.Component {
  static get propTypes () {
    return {
      children: PropTypes.node,
      classNames: PropTypes.string
    }
  }

  render () {
    return (
      <div className={[this.props.classNames, "fdn-tight fdn-search-control-group uk-button-group"].join(" ")}>
        { this.props.children }
      </div>
    )
  }
}



export class Control extends React.Component {
  static get propTypes () {
    return {
      handleClick: PropTypes.func,
      active: PropTypes.bool,
      date: PropTypes.object
    }
  }

  render () {
    var date = this.props.date

    return (
      <a onClick={this.props.handleClick} 
        className={buttonClasses(this.props.active)}>
        <span className="control-day">{date.format("ddd")}</span>
        <span className="control-day-of">{date.format("D")}</span>
      </a>
    )
  }
}

export class QuickControl extends React.Component {
  static get propTypes () {
    return {
      handleClick: PropTypes.func,
      active: PropTypes.bool,
      copy: PropTypes.string
    }
  }

  render () {
    var { copy, active } = this.props

    return (
      <a onClick={this.props.handleClick} 
        className={`fdn-search-control-single ${buttonClasses(active)}`}>
        {copy}
      </a>
    )
  }
}


export class DateControl extends React.Component {
  static get propTypes () {
    return {
      handleClick: PropTypes.func.isRequired,
      copy: PropTypes.string.isRequired,
      date: PropTypes.object,
      active: PropTypes.bool
    }
  }

  render () {
    var date = this.props.date ? moment(this.props.date) : null

    return (
      <a onClick={this.props.handleClick} 
        className={`fdn-search-control-fixed-width fdn-search-control-calendar-button
                  ${buttonClasses(this.props.active)}`}
        uk-icon='calendar'
      >
        { date ? date.format("MMM Do") : this.props.copy }
      </a>
    )
  }
}

export class DateClearControl extends React.Component {
  static get propTypes () {
    return {
      active: PropTypes.bool,
      handleClick: PropTypes.func
    }
  }

  render () {
    var { active } = this.props

    return (
      <a onClick={this.props.handleClick} 
        className={`fdn-search-control-single ${buttonClasses(active)}`}>
        All Dates
      </a>
    )
  }
}
